import { LOCALES } from '@marketplace/i18n';

export const addEditApplicationModalI18n = {
  [LOCALES.ENG]: {
    addApplicationModal_header_new: 'New App',
    addApplicationModal_header_edit: 'Edit App',

    addApplicationModal_applicationName: 'Application Name',
    addApplicationModal_shortDescription: 'Short Description',
    addApplicationModal_addType: 'Add Type',
    addApplicationModal_category: 'Category',
    addApplicationModal_work_with: 'Works with',
    addApplicationModal_tenant: 'Tenant',
    addApplicationModal_intendedUser:'Application User(s)',
    addApplicationModal_intendedPurpose:'Application Purpose(s)',
    addApplicationModal_intendedUserTitle:'Intended User(s)',
    addApplicationModal_intendedPurposeTitle:'Intended Purpose(s)',

    addApplicationModal_addAppButton: 'Add App',
    addApplicationModal_saveAppButton: 'Save App',

    addApplicationModal_cancelButton: 'Cancel',
    addApplicationModal_prevButton: 'Previous',

    addApplicationModal_facing_label:'Provider/Patient facing',
    addApplicationModal_patient: 'Patient',
    addApplicationModal_provider: 'Provider',

    addApplicationModal_save_functionality_failed : 'Error',
    addApplicationModal_save_failed_message :'Unable to save details, please contact the Admin.',
  },
};
